/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const initUpdateProductQuantity = function () {
  $(document).on('click', '.update-item', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();

      const url = $(this).attr('data-link');
      const item = sorHelpers.sorUtils.getURLParameter(url, 'item');
      const quantity = $(this)
        .parents('.order-section')
        .find('#quantity_' + item)
        .val();
      const existingQuantity = $(this).data('qty');

      if (existingQuantity === +quantity) {
        return;
      }

      $.ajax({
        type: 'POST',
        url: url,
        data: {
          quantity: quantity
        }
      })
        .done(function (response) {
          if (response) {
            if ($('#qtyError').length) {
              $('#qtyError').remove();
            }
            if (response.success) {
              window.location = SmartOrderRefillSettings.Urls.manageOrders;
            } else if (!$('#qtyError').length) {
              $('<label class="error" id="qtyError">' + response.message + '</label>').insertAfter('#quantity_' + item);
            }
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

const initRemoveProduct = function () {
  $(document).on('click', '.remove-item', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      const url = $(this).attr('data-link');
      $.ajax({
        type: 'POST',
        url: url
      })
        .done(function (response) {
          if (response.success) {
            window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

const initUpdateRefill = function () {
  $(document).on('click', '.update-refill', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      const url = $(this).attr('data-link');
      const itemID = sorHelpers.sorUtils.getURLParameter(url, 'item');
      const selectedOption = $('#select-everydelivery-' + itemID).children('option:selected');
      const data = {
        periodicity: sorHelpers.sorValidation.sanitizeString(selectedOption.attr('data-periodicity')),
        interval: sorHelpers.sorValidation.sanitizeString(selectedOption.val())
      };

      const existingPeriodicy = sorHelpers.sorValidation.sanitizeString($('#select-everydelivery-' + itemID).data('periodicity'));
      const existingInterval = sorHelpers.sorValidation.sanitizeString($('#select-everydelivery-' + itemID).data('interval'));

      if (existingPeriodicy === data.periodicity && existingInterval === +data.interval) {
        return;
      }

      $.ajax({
        type: 'POST',
        url: url,
        data: data
      })
        .done(function (response) {
          if (response && response.success) {
            window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

// Joint call between update quantity and update refill
const initUpdateQuantityRefill = function () {
  $(document).on('click', '.update-quantity-refill', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      let url = $(this).attr('data-link');
      const itemID = sorHelpers.sorUtils.getURLParameter(url, 'item');
      const selectedOption = $('#select-everydelivery-' + itemID).children('option:selected');
      const quantity = $(this)
        .parents('.order-section')
        .find('#quantity_' + itemID)
        .val();
      const data = {
        quantity: quantity
      };

      const orderId = $(this).data('oid');
      const subscriptionId = $(this).data('sid');

      const hasIntervalChanged = !selectedOption.hasClass('start-interval-value');
      if (hasIntervalChanged) {
        // If the interval has changed, update the whole subscription
        data.periodicity = sorHelpers.sorValidation.sanitizeString(selectedOption.attr('data-periodicity'));
        data.interval = sorHelpers.sorValidation.sanitizeString(selectedOption.val());
        url = url.concat('&sid=' + subscriptionId);
      } else {
        url = url.replace('action=updateQuantityRefill', 'action=updateQuantity');
        // For quantity-only updates, update the order if orderId is present, otherwise update the subscription
        if (orderId) {
          url = url.concat('&oid=' + orderId);
        } else {
          url = url.concat('&sid=' + subscriptionId);
        }
      }

      $.ajax({
        type: 'POST',
        url: url,
        data: data
      })
        .done(function (response) {
          if (response) {
            if ($('#qtyError').length) {
              $('#qtyError').remove();
            }
            if (response.success) {
              window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
            } else if (!$('#qtyError').length) {
              $('<label class="error" id="qtyError">' + response.message + '</label>').insertAfter('#quantity_' + itemID);
            }
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

const initSwitch = function () {
  $(document).on('click', '.switch-button-container', function (e) {
    e.preventDefault();
    if (e.currentTarget.hasAttribute('aria-disabled') && e.currentTarget.ariaDisabled === 'true') {
      $('.register-button').addClass('flashing');
      setTimeout(function () {
        $('.register-button').removeClass('flashing');
      }, 1000);
    }

    if (e.currentTarget.hasAttribute('aria-disabled') && e.currentTarget.ariaDisabled === 'false') {
      $(e.currentTarget).find('.sor-switch').toggleClass('active');
    }

    if ($(e.currentTarget).find('.sor-switch').hasClass('active')) {
      $('input.sor-radio-button[data-type=onetime]').prop('checked', false);
      $('input.sor-radio-button[data-type=regular]').prop('checked', true);
      $('input.sor-radio-button').trigger('change');
      $('.value-shipping').data('value', $('.value-shipping').data('value-sor'));
    } else {
      $('input.sor-radio-button[data-type=onetime]').prop('checked', true);
      $('input.sor-radio-button[data-type=regular]').prop('checked', false);
      $('input.sor-radio-button').trigger('change');
      $('.value-shipping').data('value', $('.value-shipping').data('value-default'));
    }
  });
};

module.exports = {
  initUpdateProductQuantity: initUpdateProductQuantity,
  initRemoveProduct: initRemoveProduct,
  initUpdateRefill: initUpdateRefill,
  initUpdateQuantityRefill: initUpdateQuantityRefill,
  initSwitch: initSwitch
};
